import { Container, Box } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { H2 } from "components/text/headings"

import PageHeader from "components/text/PageHeader";

import { REACT_APP_AI_API_URL } from "api/ai/ai.service";
import { ESG360 } from "components/Layout/Navbar/Navbar";
import { formatDate } from "utils";
import axios from "api/axios";
import { useAuth0 } from "@auth0/auth0-react";

export default function AboutAppPage() {
	const [aiVersion, setAiVersion] = useState(null);
	const [backendVersion, setBackendVersion] = useState(null);
	const [frontendVersion, setFrontendVersion] = useState(null);
	const { getAccessTokenSilently } = useAuth0();
	useEffect(() => {
		fetch("/.well-known/version.json")
			.then(res => res.json())
			.then(data => {
				console.log("frontend version", data);
				setFrontendVersion(data);
			});
		getAccessTokenSilently().then(token => {
			axios.get("/version")
				.then(res => {
					console.log("backend version", res.data);
					setBackendVersion(res.data);
				});
		});
		// HACK pop the /v0 version to get the server base url
		const aiUrl = REACT_APP_AI_API_URL.replace(/\/v[0-9]+/, "") + "/.well-known/version.json";
		fetch(aiUrl)
			.then(res => res.json())
			.then(data => {
				console.log("AI version", data);
				setAiVersion(data);
			});
	}, [getAccessTokenSilently]);

	return <Container>
		<PageHeader title={"About the "+ESG360+" app"} subTitle="Details of the app software and versions." />
		<H2>Frontend Version</H2>
		<Version version={frontendVersion} />
		{backendVersion && <><H2>Backend Version</H2>
			<Version version={backendVersion} /></>}
		<H2>AI Version</H2>
		<Version version={aiVersion} />
		<Box mt={4}>
			Copyright 2025 <a href="https://esg360.io">ESG360</a>. All rights reserved.
		</Box>
		<Box mt={4}>
			This app is made possible by open-source software - please ask for details.
		</Box>
		<Box mt={4}>
			<a target="_blank" href="https://www.esg360.io/privacy-policy" rel="noopener noreferrer">Privacy policy</a>
		</Box>
		</Container>;
}

function Version({ version }) {
	if (!version) return null;
	return <div>
		<p>Build-ID: {version.VERSION}</p>
		<p>Build-Date: {formatDate(version.DATE)}</p>
		{version.LLM_PROVIDER && <p>LLM: {version.LLM_PROVIDER}, model: {version.LLM_MODEL}</p>}
		{version.MESSAGE && <p>Message: {version.MESSAGE}</p>}
	</div>;
}
